export enum LotStatusDescription {
    Sold = 0,
    Available = 1,
    Unavailable = 2,
    Closed = 3,
    PendingRelease = 4,
    PendingSale = 5,
    Spec = 6,
    Model = 7,
    SpecUnavailable = 8
}
